import { getLabelMessage } from '@gef-ui/localization/messages';
import CompanyLogoFull from '@gef-ui/material/components/Logo/CompanyLogoFull';
import useIsExternalTheme from '@gef-ui/material/hooks/useIsExternalTheme';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import React from 'react';
import { errorPropType } from '../../constants';
import Error from '../Error';
import SimpleError from '../SimpleError';
const FullScreenError = ({ error, onRefresh, withSendOption, actionButton, hideHeading })=>{
    const isExternalTheme = useIsExternalTheme();
    const ErrorComponent = isExternalTheme ? SimpleError : Error;
    return /*#__PURE__*/ React.createElement(Container, {
        maxWidth: "lg"
    }, /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            paddingY: 5
        }
    }, /*#__PURE__*/ React.createElement(CompanyLogoFull, {
        width: 256
    })), /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(ErrorComponent, {
        hideHeading: hideHeading,
        error: {
            heading: getLabelMessage('errors:genericErrorHeading'),
            ...error
        },
        onRefresh: onRefresh,
        withSendOption: withSendOption,
        actionButton: actionButton
    }))));
};
FullScreenError.propTypes = {
    actionButton: PropTypes.node,
    error: errorPropType,
    hideHeading: PropTypes.bool,
    onRefresh: PropTypes.func,
    sendErrorCallback: PropTypes.func,
    versionInfoConfig: PropTypes.object,
    withSendOption: PropTypes.bool
};
export default FullScreenError;
